module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/lte-1-aa6c01e17d30f7e5f456087bd3d87309.svg";